import "./table-skeleton.scss";

const ROW_PATTERNS = [
    [55, 72, 40, 62, 45, 38],
    [70, 50, 60, 42, 55, 48],
    [45, 65, 55, 70, 35, 52],
    [62, 40, 72, 50, 65, 42],
    [50, 75, 45, 58, 40, 60],
];

function TableSkeleton({ rows = 8, columns = 5 }) {
    return (
        <div className="table-skeleton">
            <div className="table-skeleton__header">
                {Array.from({ length: columns }).map((_, i) => (
                    <div key={i} className="table-skeleton__th" />
                ))}
            </div>
            <div className="table-skeleton__body">
                {Array.from({ length: rows }).map((_, i) => (
                    <div
                        key={i}
                        className={`table-skeleton__row${i % 2 !== 0 ? " table-skeleton__row--alt" : ""}`}
                    >
                        {ROW_PATTERNS[i % ROW_PATTERNS.length]
                            .slice(0, columns)
                            .map((w, j) => (
                                <div key={j} className="table-skeleton__cell">
                                    <span className="sk-line" style={{ width: `${w}%` }} />
                                </div>
                            ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TableSkeleton;
